<template>
  <v-container fluid grid-list-lg>
    <v-layout column wrap>
      <conversion-result
        v-for="conversion in conversions"
       :key="conversion.id"
       :conversionId="conversion.id"
      >
      </conversion-result>
    </v-layout>
  </v-container>
</template>

<script>
  import ConversionResult from '@/components/converter/output/ConversionResult';

  export default {
    name: 'conversion-results',
    components: {
      'conversion-result': ConversionResult,
    },
    computed: {
      conversions() {
        return this.$store.getters.getConversions;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/converter/output/ConversionResults.vue